import React from 'react';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import { configureStore } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import rootReducer from './reducers/rootReducer';
import { appConf } from './appConf';
import App from './App';

if (appConf.SentryEnabled && appConf.SentryConfig) {
  Sentry.init(appConf.SentryConfig);
}

const queryClient = new QueryClient(); // Create a client

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false
    })
});

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <App />
      </Provider>
    </QueryClientProvider>
  );
}

// const states = store.getState();
// console.log('store', states);

serviceWorkerRegistration.register();
